export const isStringOrNull = (v)=>{
    return typeof v === 'string' || v === null;
};
